module.exports = __webpack_public_path__ + "img/25.b99c4cf6.jpg";